import { render, staticRenderFns } from "./ApproveAll.vue?vue&type=template&id=c51056e8&scoped=true"
import script from "./ApproveAll.vue?vue&type=script&lang=js"
export * from "./ApproveAll.vue?vue&type=script&lang=js"
import style0 from "./ApproveAll.vue?vue&type=style&index=0&id=c51056e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51056e8",
  null
  
)

export default component.exports